'use strict';module['exports']=function isAbsoluteURL(_0x2e0e6b){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i['test'](_0x2e0e6b);};